import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface CourseResultsBottomSheetProps {
  modalState: UseModalState;
  courseName: string;
  onBackToDocuments: () => void;
}

export function CourseResultsBottomSheet(props: CourseResultsBottomSheetProps) {
  const { modalState, courseName, onBackToDocuments } = props;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={(theme) => ({
        ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(4) }),
      })}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onBackToDocuments}>
            Continue
          </Button>
        </DialogFooter>
      }
      onClose={modalState.closeModal}
    >
      <BottomSheetIllustrationContent
        illustrationType="document-approved"
        title="Course passed!"
        description={`Your ${courseName} certificate has been added to your documents.`}
      />
    </BottomSheet>
  );
}
